// Read-only YAML / text viewer with line numbers + copy button.
import CopyButton from "@/components/CopyButton";

export default function YamlViewer({ value, testId, maxHeight = "60vh", className = "" }) {
    const text = value || "";
    const lines = text.split("\n");
    return (
        <div className={`relative bg-ux-bg-1 border border-ux-border-1 rounded-md overflow-hidden ${className}`}>
            <div className="absolute top-2 right-2 z-10">
                <CopyButton text={text} testId={`${testId || "viewer"}-copy`} />
            </div>
            <div className="flex" style={{ maxHeight }}>
                <div
                    aria-hidden
                    className="select-none text-right pr-3 pl-3 py-3 text-[12px] font-mono text-ux-text-3 border-r border-ux-border-1 bg-ux-bg-1"
                >
                    {lines.map((_, i) => (
                        <div key={i} className="leading-[1.55]">
                            {i + 1}
                        </div>
                    ))}
                </div>
                <pre
                    data-testid={testId}
                    className="flex-1 px-4 py-3 text-[13px] font-mono whitespace-pre overflow-auto leading-[1.55] text-ux-text-1"
                >
                    {text || "(empty)"}
                </pre>
            </div>
        </div>
    );
}
